import { EObjectType, IJsonQuery, setTerms } from './jsonQuery';

/**
 * Исключает из меты тип "Участок" для типа сделки - аренда
 */
export const prepareMetaParameters = (jsonQuery: IJsonQuery) => {
  return jsonQuery._type === 'suburbanrent' && jsonQuery.object_type?.value.includes(EObjectType.Land)
    ? setTerms('object_type')(jsonQuery)(jsonQuery.object_type.value.filter(type => type !== EObjectType.Land))
    : jsonQuery;
};
